import { html } from "lit";

import { customElement } from "lit/decorators.js";

import { BaseSocialButton } from "ui-components/social-login-buttons";
import { facebookLogoTemplate } from "ui-components/social-logos";

@customElement("facebook-sign-up-button")
export class FacebookSignUpButton extends BaseSocialButton {
  override render() {
    return html`${facebookLogoTemplate}`;
  }
}
